import { render, staticRenderFns } from "./StartupCosts.vue?vue&type=template&id=5b556212&scoped=true"
import script from "./StartupCosts.vue?vue&type=script&lang=js"
export * from "./StartupCosts.vue?vue&type=script&lang=js"
import style0 from "./StartupCosts.vue?vue&type=style&index=0&id=5b556212&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b556212",
  null
  
)

export default component.exports